// extracted by mini-css-extract-plugin
module.exports = {"mainFont":"\"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap\""};